module.exports = __webpack_public_path__ + "fonts/DINPro-Italic.26ee4485.otf";